export const SPOTTER_SDK_TOKEN = '6dc6327f3931b8763c6a4f4341824a';
